enum WebSocketMessageType {
  ROBOT_STATUS = 'ROBOT_STATUS',
  CLEANING_IMAGE = 'CLEANING_IMAGE',
  MISSION = 'MISSION',
  SYNC_STATUS = 'SYNC_STATUS',
  ACTIONS = 'ACTIONS',
  UNSYNCED_CHANGES = 'UNSYNCED_CHANGES',
  TEACHING = 'TEACHING',
  TORIZON_UPDATE_READY = 'TORIZON_UPDATE_READY',
  TORIZON_UPDATE_STATE = 'TORIZON_UPDATE_STATE',
}

export default WebSocketMessageType;
